export const ROLES = {
  SUPER_USER: 'SUPERUSER',
  MANAGER: 'MANAGER',
  ADMIN: 'ADMIN',
  GENERAL: 'GENERAL',
  USER: 'USER',
}

export default { ROLES }
